import { Box, Container, Card } from '@mui/material'
import { Insight } from './insight/Index'
import { SocialMediaEngagement } from './socialMediaEngagement/Index';
import { LikesAndPostsChart } from './reportsCharts/likesAndPostsChart/Index';
import { ViewsChart } from './reportsCharts/viewsChart/Index';
import { ContactInteractionChart } from './reportsCharts/contactInteractionChart/Index';
import { TopContentByViews } from './topContentByViews/Index';
import { FollowsChart } from './reportsCharts/followsChart/Index';
import { MessagingChart } from './reportsCharts/messagingChart/Index';
import { LinkClicksChart } from './reportsCharts/linkClicksChart/Index';
import { ReachChart } from './reportsCharts/reacheChart/Index';
import { useContext, useEffect, useLayoutEffect } from 'react';
import { rqx } from '../../../core/request/API';
import { env } from '../../../core/Env';
import { ToolContext } from '../../../core/context/ToolContext';

const SocialMediaInsight = () => {
    const { tool_state, social_media_insight_state } = useContext(ToolContext);
    const { userId, __SESSION } = tool_state;
    const platform = social_media_insight_state.connectedPlatform.data;

    const fetchData = async () => {
        const url = new URL(window.location.href);
        const urlPlatform = url.searchParams.get('state')?.toLowerCase();
        const currentPlatform = urlPlatform || platform;
        console.log("currentPlatform: ", currentPlatform);
        if (!currentPlatform) return;

        const bdy = {
            user_id: userId.data,
            company_id: __SESSION.data.uaccess[0].company_id,
            platform: currentPlatform === 'facebook' ? '1' : currentPlatform === 'instagram' ? '2' : '3'
        };
        console.log("bdy: ", bdy);

        const response = await rqx.get(`<<tool>>/${env()}/facebookInsights/social_account_details`, bdy);
        if (response) {
            if (response.error || response.message === "error") {
                social_media_insight_state.insightLoading.set(false);
                social_media_insight_state.topContentsLoading.set(false);
                social_media_insight_state.viewsLoading.set(false);
                social_media_insight_state.followsLoading.set(false);
                social_media_insight_state.messagingLoading.set(false)
                social_media_insight_state.reachLoading.set(false);
                social_media_insight_state.linkClicksLoading.set(false);
                social_media_insight_state.insightData.set([]);
                social_media_insight_state.topContentsData.set([]);
                return;
            }
            let all_pages = []
            if (currentPlatform === 'facebook') {
                const pages = await rqx.fbGraph('me/accounts', response?.data?.access_token, {
                    fields: 'id,name,email,picture,access_token'
                });
                all_pages = pages;
            } else if (currentPlatform === 'instagram') {
                social_media_insight_state.instagramAccountId.set(response?.data?.account_id);
                social_media_insight_state.instagramAccessToken.set(response?.data?.access_token);
                social_media_insight_state.urlCode.set("true");
            } else if (currentPlatform.toLowerCase() === 'linkedin') {
                social_media_insight_state.linkedInAccountId.set(response?.data?.account_id);
                social_media_insight_state.linkedInAccessToken.set(response?.data?.access_token);
                if (response?.data?.page_id) {
                    social_media_insight_state.selectedProfileId.set(response?.data?.page_id);
                }
                social_media_insight_state.urlCode.set("true");
            }
            const page = all_pages?.data?.find(page => page?.id === response?.data?.page_id);
            if (page) {
                social_media_insight_state.accessToken.set(page.access_token);
                social_media_insight_state.selectedProfileId.set(page.id);
                social_media_insight_state.urlCode.set("true");
            }
        }
    }
    
    useEffect(() => {
        // Check if OAuth callback is currently being processed
        const url = new URL(window.location.href);
        const isOAuthCallback = url.searchParams.get('code');
        
        // Only fetch data if OAuth callback is not being processed
        if (!isOAuthCallback && platform) {
            fetchData();
        }

        console.log("Platform: ", platform);
        console.log("Social_media_insight_state.urlCode.data: ", social_media_insight_state.urlCode.data);
        console.log("IsOAuthCallback: ", !!isOAuthCallback);
        console.log("IsOAuthCallback value: ", isOAuthCallback);
    }, [platform, social_media_insight_state.urlCode.data]);

    useLayoutEffect(() => {
        const url = new URL(window.location.href);
        const urlCode = url.searchParams.get('state');
        console.log("urlCode: ", urlCode);
        if (!urlCode) {
            url.searchParams.set('state', 'facebook');
            window.history.pushState({}, '', url);
        }
    }, [])

    return (
        <Container sx={{ display: 'flex', flexDirection: 'column', py: '30px', paddingLeft: '30px!important' }} maxWidth="xl">
            <Insight />
            <SocialMediaEngagement />
            <Box>
                <Box fontSize={18} fontWeight={600} mb="20px">
                    Social Media Like and Post Report
                </Box>
                <Card
                    sx={{
                        borderRadius: "20px",
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                        background: '#fff',
                        marginBottom: '42px'
                    }}
                >
                    <LikesAndPostsChart />
                </Card>
                <Box sx={{
                    display: 'flex',
                    gap: '45px',
                    flexDirection: { xs: 'column', md: 'row' },
                    mt: 3
                }}>
                    <Card sx={{
                        flex: 1,
                        p: 3,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                        borderRadius: '16px'
                    }}>
                        <ViewsChart />
                    </Card>
                    <Card sx={{
                        flex: 1,
                        p: 3,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                        borderRadius: '16px'
                    }}>
                        <ContactInteractionChart />
                    </Card>
                </Box>
                <Box sx={{
                    display: 'flex',
                    gap: '45px',
                    flexDirection: { xs: 'column', md: 'row' },
                    mt: '44px'
                }}>
                    <Card sx={{
                        flex: 1,
                        p: 3,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                        borderRadius: '16px'
                    }}>
                        <FollowsChart />
                    </Card>
                    <Card sx={{
                        flex: 1,
                        p: 3,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                        borderRadius: '16px'
                    }}>
                        <MessagingChart />
                    </Card>
                </Box>
                <Box sx={{
                    display: 'flex',
                    gap: '45px',
                    flexDirection: { xs: 'column', md: 'row' },
                    mt: '44px'
                }}>
                    <Card sx={{
                        flex: 1,
                        p: 3,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                        borderRadius: '16px'
                    }}>
                        <ReachChart />
                    </Card>
                    <Card sx={{
                        flex: 1,
                        p: 3,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                        borderRadius: '16px'
                    }}>
                        <LinkClicksChart />
                    </Card>
                </Box>
            </Box>
            <Box>
                <Box fontSize={24} fontWeight={600} marginBottom={'28px'} marginTop={'51px'}> Top Content by Views </Box>
                <TopContentByViews />
            </Box>
        </Container>
    )
}

export default SocialMediaInsight;